import type { Dispatch } from 'redux';
import type { SwimlaneId } from '@atlassian/jira-platform-board-kit/src/common/types.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { IssueId } from '@atlassian/jira-software-board-common/src/index.tsx';
import { appendUnscheduledWorkSwimlaneIdSuffix } from '@atlassian/jira-portfolio-3-plan-increment-common/src/common/utils.tsx';
import { VIEW_SETTINGS_PANEL } from '../../../../model/panels/constants.tsx';
import { NO_SWIMLANE } from '../../../../model/swimlane/swimlane-modes.tsx';
import {
	setShowUnscheduledColumn,
	setShowOfftrackDependencyLines,
	setIssueIdsToShowDependencies,
} from '../../../../state/actions/board/menu/index.tsx';
import { closeInsightsPanel, togglePanel } from '../../../../state/actions/panels/index.tsx';
import { swimlanesCollapse, swimlanesExpand } from '../../../../state/actions/swimlane/index.tsx';
import { getViewSettingsPanel } from '../../../../state/selectors/panels/index.tsx';
import {
	getHierarchyNomenclature,
	getIsCMPBoard,
	rapidViewIdSelector,
} from '../../../../state/selectors/software/software-selectors.tsx';
import { getSwimlaneMode } from '../../../../state/selectors/swimlane/swimlane-mode-selectors.tsx';
import { platformSwimlaneIdsSelector } from '../../../../state/selectors/work/work-selectors.tsx';
import type { State } from '../../../../state/types.tsx';
import { type DispatchProps, type StateProps, ViewSettings } from './view.tsx';

export const mapStateToProps = (state: State): StateProps => {
	const hasSwimlanes = getSwimlaneMode(state) !== NO_SWIMLANE.id;
	const isCMPBoard = getIsCMPBoard(state);
	const isViewSettingPanelOpen = getViewSettingsPanel(state);

	return {
		rapidViewId: Number(rapidViewIdSelector(state)),
		swimlaneIds: platformSwimlaneIdsSelector(state),
		isClassic: isCMPBoard,
		hasSwimlanes,
		epicCustomName: getHierarchyNomenclature(state)?.firstLevelName,
		isViewSettingPanelOpen,
	};
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	onSwimlaneExpandAll: () => {
		dispatch(swimlanesExpand());
	},
	onSwimlaneCollapseAll: (swimlaneIds: SwimlaneId[], isIPBoard: boolean) => {
		// For the program board, we want to collapse all the swimlanes in the unplanned work column as well
		const swimlanesToCollapseIds: SwimlaneId[] = isIPBoard
			? swimlaneIds.reduce<SwimlaneId[]>((acc, id) => {
					acc.push(id, appendUnscheduledWorkSwimlaneIdSuffix(id));
					return acc;
				}, [])
			: swimlaneIds;
		dispatch(swimlanesCollapse(swimlanesToCollapseIds));
	},
	onSetShowUnscheduledColumn: (isVisible: boolean) => {
		dispatch(setShowUnscheduledColumn(isVisible));
	},
	onSetShowOfftrackDependencyLines: (isVisible: boolean) => {
		dispatch(setShowOfftrackDependencyLines(isVisible));
	},
	onSetIssueIdsToShowDependencies: (issueIds: IssueId[]) => {
		dispatch(setIssueIdsToShowDependencies(issueIds));
	},
	onTogglePanel: () => {
		dispatch(togglePanel(VIEW_SETTINGS_PANEL));
		dispatch(closeInsightsPanel());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewSettings);
